/**
 * blockedCTAProps
 * @param {boolean} blocked - `blockedByTOS` from `useTOSGate`, or `blocked` from
 * `useTOSGatedAction`.
 * @returns {object} props to spread onto the gated element, after its own `cursor`.
 * @description Blocked presentation for a gated CTA that has no `disabled` concept - the `newUI`
 * Box and `useTextUI` HStack variants, which are a styled div with a raw onClick. Their disableable
 * siblings get `isDisabled={... || blockedByTOS}` and read as unavailable for free; without this
 * these read as fully clickable, and a blocked click only calls `requestConsentAttention`. On a
 * screen where the consent block is already in view - the payout side of Payment Method
 * Management, where it sits directly above the button - that scroll is a no-op, so the click has no
 * answer at all.
 *
 * Deliberately NOT `pointerEvents: "none"`, which is how the codebase's other dimmed-div idioms do
 * it (see BankRailOption): the handler must still run. `blocked` folds in "status unresolved" as
 * well as "consent needed but unticked", and a click landing mid-fetch is waited out and re-decided
 * rather than dropped (see ensureNotBlocked) - made inert, that click would be dead air instead.
 * So this changes how the control reads, and the handler guard stays the thing that enforces the
 * gate.
 */
export const blockedCTAProps = (blocked) =>
  blocked ? { opacity: 0.5, cursor: "not-allowed", "aria-disabled": true } : {};

export default blockedCTAProps;
